// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var CodeComponentPropertyControlType;
(function (CodeComponentPropertyControlType) {
    CodeComponentPropertyControlType["Boolean"] = "Boolean";
    CodeComponentPropertyControlType["Function"] = "Function";
    CodeComponentPropertyControlType["Number"] = "Number";
    CodeComponentPropertyControlType["Object"] = "Object";
    CodeComponentPropertyControlType["Slot"] = "Slot";
    CodeComponentPropertyControlType["String"] = "String";
    CodeComponentPropertyControlType["Unknown"] = "Unknown";
})(CodeComponentPropertyControlType || (CodeComponentPropertyControlType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class CodeComponentPropertyControlDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Public properties
    // isArray: boolean
    // type: CodeComponentPropertyControlType
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        // this.isArray = model.isArray
        // this.type = model.type as CodeComponentPropertyControlType
    }
}
